(() => {
  'use strict';
  const body = document.body;
  const root = body.dataset.root || '/';
  const strings = JSON.parse(document.getElementById('VpStrings')?.textContent || '{}');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const isEditor = body.dataset.designMode === 'true';
  const canMove = () => !reduced.matches && body.dataset.motion !== 'off' && !isEditor;
  const queryAll = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const header = document.querySelector('.vp-header-section');
  const measureHeader = () => { document.documentElement.style.setProperty('--vp-header-height', `${header?.getBoundingClientRect().height || 0}px`); };
  measureHeader();
  if (header && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
  const showMedia = (gallery, index) => {
    const slides = queryAll('[data-media-slide]', gallery);
    if (!slides.length) return;
    const next = (index + slides.length) % slides.length;
    slides.forEach((slide, position) => {
      slide.hidden = position !== next;
      if (slide.hidden) {
        queryAll('video', slide).forEach((video) => video.pause());
        queryAll('iframe', slide).forEach((frame) => { if (frame.dataset.mediaPlaying === 'true') { const source = frame.src; frame.src = source; frame.dataset.mediaPlaying = 'false'; } });
      } else queryAll('iframe', slide).forEach((frame) => { frame.dataset.mediaPlaying = 'true'; });
    });
    queryAll('[data-media-target]', gallery).forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === slides[next].dataset.mediaSlide)); });
    const current = gallery.querySelector('[data-gallery-current]');
    if (current) current.textContent = String(next + 1);
    if (canMove()) slides[next].animate([{ opacity: 0.5, transform: 'translateX(8px)' }, { opacity: 1, transform: 'translateX(0)' }], { duration: 220, easing: 'ease-out' });
  };
  const stepMedia = (gallery, direction) => {
    const slides = queryAll('[data-media-slide]', gallery);
    showMedia(gallery, Math.max(0, slides.findIndex((slide) => !slide.hidden)) + direction);
  };
  const touchStarts = new WeakMap();
  document.addEventListener('touchstart', (event) => {
    const gallery = event.target.closest('[data-product-gallery]');
    if (!gallery || event.touches.length !== 1 || !event.target.closest('.vp-gallery__slide>img')) return;
    touchStarts.set(gallery, { x: event.touches[0].clientX, y: event.touches[0].clientY });
  }, { passive: true });
  document.addEventListener('touchend', (event) => {
    const gallery = event.target.closest('[data-product-gallery]');
    const start = gallery && touchStarts.get(gallery);
    if (!start || !event.changedTouches.length) return;
    touchStarts.delete(gallery);
    const dx = event.changedTouches[0].clientX - start.x;
    const dy = event.changedTouches[0].clientY - start.y;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) stepMedia(gallery, dx < 0 ? 1 : -1);
  }, { passive: true });
  const announce = (message) => { const element = document.getElementById('VpAnnouncer'); if (element) element.textContent = message; };
  body.classList.add('vp-enhanced');
  let activeOpener = null;
  const closeDialog = (dialog) => {
    if (!dialog?.open) return;
    dialog.classList.add('is-closing');
    setTimeout(() => { dialog.close(); dialog.classList.remove('is-closing'); }, canMove() ? 230 : 0);
  };
  const openDialog = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    queryAll('dialog[open]').forEach((other) => { if (other !== dialog) other.close(); });
    activeOpener = opener || document.activeElement;
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    body.classList.add('vp-dialog-open');
    const input = dialog.querySelector('input[type=search]');
    if (input) input.focus({ preventScroll: true });
    return true;
  };
  document.addEventListener('close', (event) => {
    if (event.target.tagName !== 'DIALOG') return;
    if (!document.querySelector('dialog[open]')) {
      body.classList.remove('vp-dialog-open');
      if (activeOpener?.isConnected) activeOpener.focus({ preventScroll: true });
    }
  }, true);
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) { target.classList.add('is-revealed'); observer.unobserve(target); }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' }) : null;
  const stickyObservers = new WeakMap();
  const init = (scope = document) => {
    queryAll('[data-reveal]', scope).forEach((element) => {
      if (canMove() && observer && !element.classList.contains('is-revealed')) { element.classList.add('vp-reveal-pending'); observer.observe(element); }
      else { element.classList.add('is-revealed'); }
    });
    queryAll('[data-variant-input]', scope).forEach((input) => { input.disabled = false; });
    queryAll('[data-product-section]', scope).forEach((section) => {
      const row = section.querySelector('.vp-buy-row');
      const bar = section.querySelector('.vp-sticky-buy');
      if (!row || !bar || !observer) return;
      stickyObservers.get(section)?.disconnect();
      const sticky = new IntersectionObserver(([entry]) => { bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0); }, { threshold: 0 });
      sticky.observe(row);
      stickyObservers.set(section, sticky);
    });
    updateSavedButtons();
  };
  reduced.addEventListener('change', () => {
    queryAll('.vp-reveal-pending').forEach((element) => element.classList.add('is-revealed'));
    queryAll('.vp-hero__visual').forEach((element) => { element.style.transform = ''; });
  });
  let scrollScheduled = false;
  const onScroll = () => {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      document.querySelector('.vp-header')?.classList.toggle('is-scrolled', window.scrollY > 20);
      if (canMove() && body.dataset.motion === 'standard' && body.dataset.parallax === 'true' && window.innerWidth > 749) {
        queryAll('.vp-hero__visual[data-parallax]').forEach((element) => {
          const rect = element.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const amount = Math.max(-24, Math.min(24, (window.innerHeight / 2 - rect.top - rect.height / 2) * 0.1));
          element.style.transform = `translate3d(0,${amount.toFixed(2)}px,0)`;
        });
      }
      scrollScheduled = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { if (window.innerWidth <= 749) queryAll('.vp-hero__visual').forEach((e) => { e.style.transform = ''; }); onScroll(); }, { passive: true });
  const activateTab = (tab) => {
    const section = tab.closest('[data-product-tabs]');
    queryAll('[data-tab]', section).forEach((item) => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
    queryAll('[data-panel]', section).forEach((panel) => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; if (!panel.hidden) init(panel); });
  };
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') queryAll('[data-nav-details][open],[data-mobile-menu][open]').forEach((details) => { details.open = false; });
    const gallery = event.target.closest('[data-product-gallery]');
    if (gallery && !event.ctrlKey && !event.metaKey && !event.altKey && (event.target === gallery || event.target.matches('[data-media-step],[data-media-target]')) && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      if (event.key === 'Home') showMedia(gallery, 0);
      else if (event.key === 'End') showMedia(gallery, queryAll('[data-media-slide]', gallery).length - 1);
      else stepMedia(gallery, event.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    if (!event.target.matches('[data-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = queryAll('[data-tab]', event.target.closest('[data-product-tabs]'));
    const index = tabs.indexOf(event.target);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(tabs[next]); tabs[next].focus();
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('[data-nav-details]') && event.target.open) queryAll('[data-nav-details]').forEach((details) => { if (details !== event.target) details.open = false; });
  }, true);
  const key = 'aqua-motion-saved-v1';
  let saved = [];
  try { const parsed = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(parsed)) saved = parsed.filter((item) => item && typeof item.handle === 'string' && typeof item.title === 'string' && typeof item.url === 'string').slice(0, 60); } catch {}
  const saveState = () => { try { localStorage.setItem(key, JSON.stringify(saved)); } catch {} updateSavedButtons(); };
  function updateSavedButtons() {
    queryAll('[data-save]').forEach((button) => { button.setAttribute('aria-pressed', String(saved.some((item) => item.handle === button.dataset.handle))); });
    queryAll('[data-saved-count]').forEach((counter) => { counter.textContent = String(saved.length); counter.hidden = saved.length === 0; });
  }
  const safeUrl = (value, fallback) => { try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : fallback; } catch { return fallback; } };
  const renderSaved = () => {
    const list = document.querySelector('[data-saved-list]');
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) { const empty = document.createElement('p'); empty.className = 'vp-empty'; empty.textContent = strings.empty; list.append(empty); return; }
    saved.forEach((item) => {
      const wrapper = document.createElement('article'); wrapper.className = 'vp-saved-item';
      const imageLink = document.createElement('a'); imageLink.href = safeUrl(item.url, `${root}products/${encodeURIComponent(item.handle)}`);
      if (item.image) { const image = document.createElement('img'); image.src = safeUrl(item.image, ''); image.alt = item.title; image.loading = 'lazy'; imageLink.append(image); }
      const info = document.createElement('div'); const title = document.createElement('h3'); const link = document.createElement('a'); link.href = imageLink.href; link.textContent = item.title; title.append(link);
      const price = document.createElement('p'); price.textContent = item.price || '';
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'vp-text-button'; remove.dataset.removeSaved = item.handle; remove.textContent = strings.remove;
      info.append(title, price, remove); wrapper.append(imageLink, info); list.append(wrapper);
    });
  };
  const renderCart = (html, count, focusKey) => {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newDialog = parsed.getElementById('VpCart'); const oldDialog = document.getElementById('VpCart');
    if (!newDialog || !oldDialog) return false;
    const wasOpen = oldDialog.open;
    if (wasOpen) oldDialog.close();
    oldDialog.replaceWith(newDialog);
    queryAll('[data-cart-count]').forEach((counter) => { counter.textContent = String(count); counter.hidden = count === 0; });
    if (wasOpen || focusKey) openDialog(newDialog, activeOpener);
    if (focusKey) queryAll('[data-cart-change]', newDialog).find((button) => button.dataset.key === focusKey)?.focus({ preventScroll: true });
    return true;
  };
  const refreshCart = async (sections) => {
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error(strings.error);
    const cart = await cartResponse.json();
    let html = sections?.['vp-cart-drawer'];
    if (!html) { const response = await fetch(`${root}cart?sections=vp-cart-drawer`); if (!response.ok) throw new Error(strings.error); html = (await response.json())['vp-cart-drawer']; }
    if (!renderCart(html, cart.item_count)) throw new Error(strings.error);
    return document.getElementById('VpCart');
  };
  let cartBusy = false;
  const changeCart = async (button) => {
    if (cartBusy) return;
    cartBusy = true;
    const dialog = document.getElementById('VpCart');
    queryAll('[data-cart-change]', dialog).forEach((control) => { control.disabled = true; });
    const error = dialog.querySelector('[data-cart-error]'); error.hidden = true;
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.key, quantity: Number(button.dataset.quantity), sections: ['vp-cart-drawer'], sections_url: location.pathname }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || strings.error);
      if (!renderCart(data.sections?.['vp-cart-drawer'], data.item_count, button.dataset.key)) await refreshCart(data.sections);
    } catch (failure) { error.textContent = failure.message; error.hidden = false; }
    finally { cartBusy = false; queryAll('[data-cart-change]').forEach((control) => { control.disabled = false; }); }
  };
  document.addEventListener('click', (event) => {
    const pickerOption = event.target.closest('[data-picker-option]');
    if (pickerOption) {
      const group = pickerOption.closest('[data-picker-group]');
      const select = group.querySelector('[data-option-select]');
      select.value = pickerOption.dataset.pickerOption;
      queryAll('[data-picker-option]', group).forEach((button) => button.setAttribute('aria-pressed', String(button === pickerOption)));
      group.querySelector('[data-picker-value]').textContent = pickerOption.dataset.pickerName;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const close = event.target.closest('[data-close-dialog]'); if (close) { closeDialog(close.closest('dialog')); return; }
    if (event.target.tagName === 'DIALOG') { const rect = event.target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(event.target); }
    const search = event.target.closest('[data-open-search]'); if (search && openDialog(document.getElementById('VpSearch'), search)) { event.preventDefault(); return; }
    const cart = event.target.closest('[data-open-cart]'); if (cart && openDialog(document.getElementById('VpCart'), cart)) { event.preventDefault(); return; }
    const savedOpener = event.target.closest('[data-open-saved]'); if (savedOpener) { renderSaved(); openDialog(document.getElementById('VpSaved'), savedOpener); return; }
    const save = event.target.closest('[data-save]');
    if (save) { const index = saved.findIndex((item) => item.handle === save.dataset.handle); if (index >= 0) { saved.splice(index, 1); announce(strings.removed); } else { saved.unshift({ handle: save.dataset.handle, title: save.dataset.title, url: save.dataset.url, image: save.dataset.image, price: save.dataset.price }); saved = saved.slice(0, 60); announce(strings.saved); } saveState(); return; }
    const remove = event.target.closest('[data-remove-saved]'); if (remove) { saved = saved.filter((item) => item.handle !== remove.dataset.removeSaved); saveState(); renderSaved(); announce(strings.removed); return; }
    const tab = event.target.closest('[data-tab]'); if (tab) { activateTab(tab); return; }
    const railControl = event.target.closest('[data-rail-prev],[data-rail-next]');
    if (railControl) { const rail = railControl.closest('[data-panel]').querySelector('[data-rail]'); const direction = railControl.hasAttribute('data-rail-prev') ? -1 : 1; rail.scrollBy({ left: direction * (rail.clientWidth + 24), behavior: canMove() ? 'smooth' : 'instant' }); return; }
    const pause = event.target.closest('[data-marquee-pause]'); if (pause) { const paused = pause.closest('[data-marquee]').classList.toggle('is-paused'); pause.setAttribute('aria-pressed', String(paused)); return; }
    const announcement = event.target.closest('[data-close-announcement]'); if (announcement) { announcement.closest('[data-announcement]').hidden = true; return; }
    const mediaStep = event.target.closest('[data-media-step]');
    if (mediaStep) { stepMedia(mediaStep.closest('[data-product-gallery]'), Number(mediaStep.dataset.mediaStep)); return; }
    const media = event.target.closest('[data-media-target]');
    if (media) { const gallery = media.closest('[data-product-gallery]'); showMedia(gallery, queryAll('[data-media-slide]', gallery).findIndex((slide) => slide.dataset.mediaSlide === media.dataset.mediaTarget)); return; }
    const quantity = event.target.closest('[data-qty]'); if (quantity) { const input = quantity.closest('.vp-quantity').querySelector('input'); try { Number(quantity.dataset.qty) > 0 ? input.stepUp() : input.stepDown(); } catch {} input.dispatchEvent(new Event('change', { bubbles: true })); return; }
    const change = event.target.closest('[data-cart-change]'); if (change) { changeCart(change); return; }
    queryAll('[data-nav-details][open],[data-mobile-menu][open]').forEach((details) => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches('[data-vp-add]') || form.dataset.vpAdd === 'false' || typeof HTMLDialogElement === 'undefined') return;
    const buttons = queryAll('button[type=submit]', form);
    if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
    if (!form.checkValidity()) return;
    event.preventDefault();
    form.dataset.submitting = 'true'; buttons.forEach((button) => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    const error = form.querySelector('[data-product-error]'); if (error) error.hidden = true;
    const data = new FormData(form); data.append('sections', 'vp-cart-drawer'); data.append('sections_url', location.pathname);
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || strings.error);
      if (event.submitter?.hasAttribute('data-buy-now')) { location.assign(`${root}checkout`); return; }
      announce(strings.added);
      try { const dialog = await refreshCart(result.sections); openDialog(dialog, event.submitter || form); }
      catch { location.assign(`${root}cart`); }
    } catch (failure) { if (error) { error.textContent = failure.message; error.hidden = false; } else { announce(failure.message); const notification = document.createElement('p'); notification.className = 'vp-form-error'; notification.setAttribute('role', 'alert'); notification.textContent = failure.message; form.closest('.vp-card').append(notification); setTimeout(() => notification.remove(), 7000); } }
    finally { form.dataset.submitting = 'false'; buttons.forEach((button) => { button.disabled = false; button.removeAttribute('aria-busy'); }); }
  });
  const variantRequests = new WeakMap();
  // Keep app blocks and their ancestors connected. Moving a live app into a
  // detached section restarts custom elements and duplicates sliders/bundles.
  const syncVariant = (section, fresh) => {
    ['.vp-product-info__price', '.vp-stock'].forEach((selector) => {
      const current = section.querySelector(selector);
      const next = fresh.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    });
    queryAll('[data-option-select]', section).forEach((select) => {
      const next = queryAll('[data-option-select]', fresh).find((item) => item.id === select.id);
      if (next) { select.innerHTML = next.innerHTML; select.value = next.value; }
    });
    queryAll('[data-picker-group]', section).forEach((group) => {
      const next = queryAll('[data-picker-group]', fresh).find((item) => item.dataset.pickerGroup === group.dataset.pickerGroup);
      if (!next) return;
      group.querySelector('[data-picker-value]').textContent = next.querySelector('[data-picker-value]').textContent;
      queryAll('[data-picker-option]', group).forEach((button) => {
        const updated = queryAll('[data-picker-option]', next).find((item) => item.dataset.pickerOption === button.dataset.pickerOption);
        if (!updated) return;
        button.setAttribute('aria-pressed', updated.getAttribute('aria-pressed'));
        button.setAttribute('aria-label', updated.getAttribute('aria-label'));
        button.toggleAttribute('data-unavailable', updated.hasAttribute('data-unavailable'));
      });
    });
    const input = section.querySelector('[data-variant-input]');
    const nextInput = fresh.querySelector('[data-variant-input]');
    if (input && nextInput) { input.value = nextInput.value; input.setAttribute('value', nextInput.value); input.disabled = false; }
    const quantity = section.querySelector('.vp-product-form input[name=quantity]');
    const nextQuantity = fresh.querySelector('.vp-product-form input[name=quantity]');
    if (quantity && nextQuantity) {
      ['min', 'max', 'step'].forEach((name) => {
        if (nextQuantity.hasAttribute(name)) quantity.setAttribute(name, nextQuantity.getAttribute(name));
        else quantity.removeAttribute(name);
      });
      const min = Number(quantity.min || 1), step = Number(quantity.step || 1);
      const value = Math.max(min, Math.min(Number(quantity.max || Infinity), Number(quantity.value) || min));
      quantity.value = String(min + Math.floor((value - min) / step) * step);
    }
    const buttons = queryAll('.vp-buy-row > button[type=submit], .vp-sticky-buy > button', section);
    const nextButtons = queryAll('.vp-buy-row > button[type=submit], .vp-sticky-buy > button', fresh);
    buttons.forEach((button, index) => {
      const next = nextButtons[index];
      if (next) { button.innerHTML = next.innerHTML; button.disabled = next.disabled; }
    });
    const stickyPrice = section.querySelector('.vp-sticky-buy > span:nth-child(2)');
    const nextPrice = fresh.querySelector('.vp-sticky-buy > span:nth-child(2)');
    if (stickyPrice && nextPrice) stickyPrice.innerHTML = nextPrice.innerHTML;
    const gallery = section.querySelector('[data-product-gallery]');
    const activeMedia = fresh.querySelector('[data-media-slide]:not([hidden])')?.dataset.mediaSlide;
    if (gallery && activeMedia) {
      const index = queryAll('[data-media-slide]', gallery).findIndex((slide) => slide.dataset.mediaSlide === activeMedia);
      if (index >= 0) showMedia(gallery, index);
    }
    const schema = section.querySelector('script[type="application/ld+json"]');
    const nextSchema = fresh.querySelector('script[type="application/ld+json"]');
    if (schema && nextSchema) schema.textContent = nextSchema.textContent;
    section.dataset.productUrl = fresh.dataset.productUrl;
    section.dataset.variantAvailable = fresh.dataset.variantAvailable;
    const historyUrl = new URL(location.href);
    historyUrl.searchParams.delete('option_values');
    if (input?.value) historyUrl.searchParams.set('variant', input.value);
    else historyUrl.searchParams.delete('variant');
    history.replaceState({}, '', historyUrl);
    // Existing app listeners stay attached to this same input and form.
    input?.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('submit', (event) => {
    const section = event.target.closest('[data-product-section]');
    if (!section || !event.target.matches('.vp-product-form')) return;
    if (section.hasAttribute('aria-busy') || section.dataset.variantAvailable === 'false' || section.dataset.variantError === 'true') {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', async (event) => {
    if (event.target.matches('[data-localization]')) { event.target.form.requestSubmit(); return; }
    if (event.target.matches('[data-sort]')) { event.target.form.requestSubmit(); return; }
    if (!event.target.matches('[data-option-select]')) return;
    const section = event.target.closest('[data-product-section]');
    if (!section) return;
    variantRequests.get(section)?.abort();
    const controller = new AbortController(); variantRequests.set(section, controller);
    const optionIds = queryAll('[data-option-select]', section).map((select) => select.value);
    const url = new URL(event.target.selectedOptions[0]?.dataset.productUrl || section.dataset.productUrl, location.origin);
    if (url.pathname !== new URL(section.dataset.productUrl, location.origin).pathname) {
      location.assign(url); return;
    }
    url.searchParams.set('section_id', section.dataset.sectionId);
    url.searchParams.set('option_values', optionIds.join(','));
    const content = section.querySelector('[data-product-content]');
    content?.classList.add('vp-is-loading'); section.setAttribute('aria-busy', 'true');
    const error = section.querySelector('[data-product-error]');
    if (error) error.hidden = true;
    try {
      const response = await fetch(url.toString(), { signal: controller.signal });
      if (!response.ok) throw new Error(strings.error);
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted || !section.isConnected) return;
      const fresh = parsed.querySelector('[data-product-section]');
      if (!fresh?.querySelector('[data-product-content]')) throw new Error(strings.error);
      syncVariant(section, fresh);
      delete section.dataset.variantError;
      announce(section.querySelector('.vp-stock')?.textContent.trim() || '');
    } catch (failure) {
      if (failure.name !== 'AbortError') {
        section.dataset.variantError = 'true';
        if (error) { error.textContent = failure.message; error.hidden = false; }
        else announce(failure.message);
      }
    } finally {
      if (variantRequests.get(section) === controller) { content?.classList.remove('vp-is-loading'); section.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => { const panel = event.target.closest('[data-panel]'); if (panel) { const tab = queryAll('[data-tab]', panel.closest('[data-product-tabs]')).find((button) => button.dataset.tab === panel.dataset.panel); if (tab) activateTab(tab); } });
  document.addEventListener('shopify:section:unload', (event) => { const section = event.target.querySelector('[data-product-section]'); if (section) { stickyObservers.get(section)?.disconnect(); variantRequests.get(section)?.abort(); } queryAll('[data-reveal]', event.target).forEach((element) => observer?.unobserve(element)); });
  init(); onScroll();
})();
